import React, { useState, useEffect } from "react";
import { fetchMeetupTarget } from "../../api/fetchMeetupTarget";

const SITE_URL = "https://stavanger.ixda.no";

// Same channels as CHANNELS in netlify/functions/meetup-click.js, plus the plain link (counted as direct)
const LINKS = [
  { label: "Instagram bio", path: "/meetup/instagram" },
  { label: "LinkedIn", path: "/meetup/linkedin" },
  { label: "Slack", path: "/meetup/slack" },
  { label: "Other places", note: "counted as direct", path: "/meetup" },
];

const CopyButton = ({ text }) => {
  const [status, setStatus] = useState(null);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setStatus("Copied");
    } catch (error) {
      console.error("Error copying link:", error);
      setStatus("Copy failed");
    }
    setTimeout(() => setStatus(null), 2000);
  };

  return (
    <button onClick={copy} className={`promo-links-copy${status === "Copied" ? " copied" : ""}`}>
      {status || "Copy"}
    </button>
  );
};

const MeetupLinks = () => {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    fetchMeetupTarget().then(setTarget);
  }, []);

  // The ?m= example uses the current meetup's number, so it can be copied for the next post
  const exampleMeetupNo = target?.event?.eventMeetupNo ?? 62;

  return (
    <aside className="promo-links">
      <h2 className="promo-links-title">Meetup links</h2>
      <p className="promo-links-text">
        Use these instead of the Meetup.com event link. They always go to the newest meetup in
        Sanity, so they never have to be changed. To send them somewhere else, fill in "Meetup link
        override" under Site Configuration in Sanity.
      </p>
      <p className="promo-links-text">
        Every click is counted under 📊 Meetup clicks in Sanity, per meetup and channel. Use the
        link for the place you post it, so the numbers show where people come from. Link previews
        in Slack and LinkedIn are not counted.
      </p>
      <p className="promo-links-text">
        To link to one specific meetup, add ?m= and the meetup number, for example{" "}
        {SITE_URL}/meetup/instagram?m={exampleMeetupNo}. That link keeps going to Meetup #
        {exampleMeetupNo} after newer meetups are published, and its clicks are counted on that
        meetup. Use it in posts about one meetup, and the plain links in places that should always
        show the next meetup, like the Instagram bio.
      </p>
      {target && (
        <p className="promo-links-text promo-links-target">
          Right now they go to{" "}
          <a href={target.url} target="_blank" rel="noopener noreferrer">
            {target.event
              ? `Meetup #${target.event.eventMeetupNo}: ${target.event.eventName}`
              : target.url}
          </a>
        </p>
      )}
      <ul className="promo-links-list">
        {LINKS.map(({ label, note, path }) => (
          <li key={path} className="promo-links-item">
            <div>
              <span className="promo-links-label">
                {label}
                {note && <span className="promo-links-note"> ({note})</span>}
              </span>
              <span className="promo-links-url">{SITE_URL + path}</span>
            </div>
            <CopyButton text={SITE_URL + path} />
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default MeetupLinks;
